export const ATTENDANCE_CHALLENGE_ROUTE = 'attendance-challenge';
